import { SyntheticEvent } from 'react';
import { useEffect } from 'react';
import { useParams } from 'react-router-dom';

import { useGetProjectDetailsQuery } from './api/adminProjectsApiSlice';
import { ADMIN_PROJECT_TABS, type AdminProjectTabType } from './constants';
import {
  clearDefaultAllocationModeEdit,
  setDefaultAllocationModeEdit,
  setSelectedTab,
} from './state/adminProjectSlice';
import { selectSelectedTab } from './state/selector';
import { useAppDispatch, useAppSelector } from '../../lib/store';

export const useProjectDetails = () => {
  const { projectId } = useParams();
  const dispatch = useAppDispatch();

  const selectedTab = useAppSelector(selectSelectedTab) ?? ADMIN_PROJECT_TABS.OVERVIEW;

  const handleTabChange = (event: SyntheticEvent, value: AdminProjectTabType) => {
    event.preventDefault();
    dispatch(setSelectedTab(value as AdminProjectTabType));
  };
  const {
    data: projectDetailsData,
    isLoading: isProjectDetailsLoading,
    isFetching: isProjectDetailsFetching,
  } = useGetProjectDetailsQuery(
    { projectId: projectId as string },
    { skip: !projectId || projectId === '' }
  );

  useEffect(() => {
    if (projectDetailsData?.data?.defaultAllocationMode ?? false) {
      dispatch(setDefaultAllocationModeEdit());
    } else {
      dispatch(clearDefaultAllocationModeEdit());
    }
  }, [projectDetailsData?.data?.defaultAllocationMode]);

  return {
    projectId,
    projectName: projectDetailsData?.data?.basics?.projectName ?? '',
    createdOn: projectDetailsData?.data?.createdAt ?? '',
    startedOn: projectDetailsData?.data?.startDate ?? '',
    completedOn: projectDetailsData?.data?.completedDate ?? '',
    isProjectDetailsLoading: isProjectDetailsLoading || isProjectDetailsFetching,
    selectedTab,
    handleTabChange,
  };
};
